import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import Autocomplete from "@mui/material/Autocomplete";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Box, IconButton, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import {
  LOG_MODULE_API_NAME,
  ServiceList,
  SHAREPOINT_CONN_NAME,
  WORKDRIVE_CONN_NAME,
} from "../../../config/serviceConstant";
import RootFolderSelection from "../../Service/Workdrive/RootFolderSelection/RootFolderSelection";
import * as OtherAPICalling from "../../../APICalling/Other";
import SharepointRootFolderSelection from "../../Service/Sharepoint/SharepointRootFolderSelection/SharepointRootFolderSelection";
import { getRecordName } from "../../../config/otherConstant";

const warningMessage = `If you revoke it, all kinds of automation including WORKFLOWS, WIDGETS,
            BUTTONS , RELATED LIST and SETTINGS will be DISABLED`;
const ZOHO = window.ZOHO;

function CreateNewSettingModal(props) {
  const { orgid, apikey, datacenterurl, datacenter, zuid, setReload } = props;
  const [createNewSettingOpen, setCreateNewSettingOpen] = useState(false);
  const [modules, setModules] = useState([]);
  const [modulefields, setModulefields] = useState([]);
  const [customViewList, setCustomViewList] = useState([]);
  const [settingData, setSettingData] = useState({});
  const [sharepointSettingData, setSharepointSettingData] = useState({});
  const {
    register,
    getValues,
    setValue,
    reset,
    resetField,
    control,
    handleSubmit,
    watch,
  } = useForm({
    defaultValues: {},
  });

  const onSubmit = async (data) => {
    let config = {
      data: {
        settingId: data?.settingId || "",
        settingSchema: data,
        showInRelatedList: false,
        moduleApiName: data?.module?.apiName,
        settingType: "moduleCron",
      },
      orgid,
      apikey,
      datacenter,
      datacenterurl,
    };
    const upsertSettingResp = await OtherAPICalling.upsertSetting(config);

    reset();
    setReload((prev) => !prev);
    // handleCreateSetting(data);
  };

  const handleClickNewSettingOpen = () => {
    setCreateNewSettingOpen(true);
  };

  const handleRevokeClose = () => {
    setCreateNewSettingOpen(false);
  };

  useEffect(() => {
    async function fetchModules() {
      try {
        const moduleResp = await ZOHO.CRM.META.getModules();
        let modules = moduleResp?.modules
          ?.filter((module) => module?.isBlueprintSupported)
          ?.map((module) => {
            return {
              displayLabel: module.plural_label,
              apiName: module.api_name,
            };
          });
        setModules((prev) => modules);
      } catch (error) {}
    }

    async function fetchLogModuleViews() {
      try {
        const customViewResp = await ZOHO.CRM.META.getCustomViews({
          Entity: LOG_MODULE_API_NAME,
        });
        const customViews = customViewResp?.custom_views?.map((cv) => {
          return { displayLabel: cv?.name, id: cv?.id };
        });
        setCustomViewList((prev) => customViews);
      } catch (error) {}
    }
    fetchModules();
    fetchLogModuleViews();
  }, []);

  useEffect(() => {
    async function fetchModuleFields() {
      try {
        const fieldsResp = await ZOHO.CRM.META.getFields({
          Entity: watch("module")?.apiName,
        });

        const modulefields = fieldsResp?.fields
          ?.filter(
            (field) =>
              field.data_type !== "lookup" && field.data_type !== "ownerlookup"
          )
          ?.map((field) => {
            return {
              lookupApiName: "",
              lookupDisplayLabel: watch("module")?.displayLabel,
              fieldApiName: field?.api_name,
              fieldDisplayLabel: field?.display_label,
              type: field?.data_type,
            };
          });
        setModulefields((prev) => modulefields);
      } catch (error) {}
    }
    if (watch("module")) {
      fetchModuleFields();
    }
  }, [watch("module")]);

  return (
    <>
      <Button variant="contained" onClick={handleClickNewSettingOpen}>
        Create Setting
      </Button>
      <Dialog
        open={createNewSettingOpen}
        onClose={handleRevokeClose}
        aria-labelledby="alert-dialog-title"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{ fontWeight: 600, fontSize: "18px", pb: 0 }}
          id="alert-dialog-title"
        >
          New Setting
          <IconButton
            onClick={handleRevokeClose}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon onClick={handleRevokeClose} />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Box
            id="settingForm"
            component="form"
            onSubmit={handleSubmit(onSubmit)}
          >
            <>
              <Typography sx={{ fontWeight: 500, fontSize: "14px", mb: 1 }}>
                Choose Backup Platform <span style={{ color: "red" }}>*</span>
              </Typography>
              <Controller
                name="service"
                control={control}
                render={({ field }) => (
                  <Autocomplete
                    autoHighlight
                    size="small"
                    options={ServiceList}
                    getOptionLabel={(option) => option?.displayLabel}
                    onChange={(e, value) => {
                      setValue("rootFolder", null);
                      field.onChange(value);
                    }}
                    value={field?.value}
                    disableClearable
                    required
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Select a backup platform"
                        helperText="Choose the backup platform where attacments will be saved (e.g., WorkDrive, SharePoint)."
                        fullWidth
                        required
                      />
                    )}
                    sx={{ mb: 1 }}
                  />
                )}
              />
              <Typography sx={{ fontWeight: 500, fontSize: "14px", mb: 1 }}>
                Select Module <span style={{ color: "red" }}>*</span>
              </Typography>
              <Controller
                name="module"
                control={control}
                render={({ field }) => (
                  <Autocomplete
                    autoHighlight
                    size="small"
                    options={modules}
                    getOptionLabel={(option) => option?.displayLabel}
                    onChange={(e, value) => field.onChange(value)}
                    value={field?.value}
                    disableClearable
                    required
                    disabled={modules?.length === 0}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Select a CRM module"
                        helperText="Pick the CRM module for which you want to define attachment backup rules."
                        fullWidth
                        required
                      />
                    )}
                    sx={{ mb: 1 }}
                  />
                )}
              />
              <Typography sx={{ fontWeight: 500, fontSize: "14px", mb: 1 }}>
                Select Fields
              </Typography>
              {/* Field Selection */}
              <Controller
                name="modulefield"
                control={control}
                render={({ field }) => (
                  <Autocomplete
                    autoHighlight
                    size="small"
                    options={modulefields}
                    getOptionLabel={(option) => option?.fieldDisplayLabel}
                    onChange={(e, value) => field.onChange(value)}
                    value={field?.value}
                    disabled={modulefields?.length === 0}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Select CRM fields"
                        helperText="Field used to fetch folder ID(e.g. Workdrive Folder ID). If empty, a new folder will be created under root folder."
                        fullWidth
                      />
                    )}
                    sx={{ mb: 1 }}
                  />
                )}
              />

              <Box mb={3}>
                {watch("service")?.apiName === "workdrive" && (
                  <>
                    <Typography sx={{ fontWeight: 500, fontSize: "14px" }}>
                      Select Root Folder <span style={{ color: "red" }}>*</span>
                    </Typography>

                    <RootFolderSelection
                      source="setting"
                      settingData={settingData}
                      module={module}
                      apiData={null}
                      saveApiData={(data) => {}}
                      saveData={(data) => {
                        if (data?.key === "rootFolder" && data?.response?.id) {
                          setSettingData((prev) => ({
                            ...prev,
                            rootFolder: data.response,
                          }));
                          setValue("rootFolder", data.response);
                        }
                        if (data?.key === "workspace" && data?.response?.id) {
                          setSettingData((prev) => ({
                            ...prev,
                            workspace: data.response,
                          }));
                          setValue("workspace", data.response);
                        }
                        if (data?.key === "teamFolder" && data?.response?.id) {
                          setSettingData((prev) => ({
                            ...prev,
                            teamFolder: data.response,
                          }));
                          setValue("teamFolder", data.response);
                        }
                      }}
                      folderDetails={null}
                      setFolderDetails={(data) => {}}
                      addFolder={(data) => {}}
                      orgid={orgid}
                      connname={WORKDRIVE_CONN_NAME}
                      apikey={apikey}
                      datacenterurl={datacenterurl}
                      datacenter={datacenter}
                      zuid={zuid}
                    />
                    <Typography
                      sx={{
                        fontSize: "13px",
                        ml: 2,
                        fontWeight: 400,
                        color: "#6B7280",
                        mt: "5px",
                      }}
                    >
                      Choose the main folder in the connected drive where
                      record-specific folders will be created and attachments
                      will be stored.
                    </Typography>
                  </>
                )}

                {watch("service")?.apiName === "sharepoint" && (
                  <>
                    <Typography
                      sx={{ fontWeight: 500, fontSize: "14px", mb: 1 }}
                    >
                      Select Root Folder <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <SharepointRootFolderSelection
                      rootFolderID={null}
                      settingData={sharepointSettingData}
                      module=""
                      apiData={null}
                      saveApiData={(data) => {}}
                      saveData={(data) => {
                        if (data?.key === "rootFolder" && data?.response?.id) {
                          setSharepointSettingData((prev) => ({
                            ...prev,
                            rootFolder: data.response,
                          }));
                          setValue("rootFolder", data.response);
                        }
                        if (data?.key === "workspace" && data?.response?.id) {
                          setSharepointSettingData((prev) => ({
                            ...prev,
                            site: data.response,
                          }));
                          setValue("site", data.response);
                        }
                        if (data?.key === "teamFolder" && data?.response?.id) {
                          setSharepointSettingData((prev) => ({
                            ...prev,
                            drive: data.response,
                          }));
                          setValue("drive", data.response);
                        }
                      }}
                      folderDetails={null}
                      setFolderDetails={(data) => {}}
                      addFolder={(data) => {}}
                      orgid={orgid}
                      connname={SHAREPOINT_CONN_NAME}
                      apikey={apikey}
                      datacenterurl={datacenterurl}
                      zuid={zuid}
                      settingUrl={
                        process.env.REACT_APP_DRIVEMANAGER_SETTING_URL
                      }
                    />
                    <Typography
                      sx={{
                        fontSize: "13px",
                        ml: 2,
                        fontWeight: 400,
                        color: "#6B7280",
                        mt: "5px",
                      }}
                    >
                      Select the root folder in your drive under which all
                      folders for this module’s records will be created. If no
                      folder ID exists for a record, a new folder will be
                      automatically created inside this root folder.
                    </Typography>
                  </>
                )}
              </Box>
              {getValues("rootFolder") ? (
                <Box
                  sx={{
                    backgroundColor: "#F1F6FF",
                    borderLeft: "3px solid #1976D2",
                    color: "#333",
                    fontSize: "14px",
                    p: 2,
                    borderRadius: 2,
                    mb: 3,
                  }}
                >
                  {watch("service")?.apiName === "workdrive" &&
                  watch("modulefield")?.fieldDisplayLabel ? (
                    <Typography variant="body2">
                      <strong>ℹ️ {getValues("module")?.displayLabel}</strong>{" "}
                      attachments will be saved in record folder. This folder Id
                      should exist in{" "}
                      <strong>
                        {getValues("modulefield")?.fieldDisplayLabel}
                      </strong>{" "}
                      field otherwise a folder will be created for each record
                      in below structure:{" "}
                      <strong>
                        {getValues("workspace")?.name} /{" "}
                        {getValues("teamFolder")?.name} /{" "}
                        {getValues("rootFolder")?.name} /{" "}
                        {`{${getRecordName(getValues("module")?.apiName)}}__{${
                          getValues("module")?.displayLabel
                        } ID}`}
                      </strong>
                    </Typography>
                  ) : (
                    <></>
                  )}
                  {watch("service")?.apiName === "workdrive" &&
                  !watch("modulefield")?.fieldDisplayLabel ? (
                    <Typography variant="body2">
                      <strong>ℹ️ {getValues("module")?.displayLabel}</strong>{" "}
                      attachments will be saved in record folder. Folder will be
                      created for each record in below structure:{" "}
                      <strong>
                        {getValues("workspace")?.name} /{" "}
                        {getValues("teamFolder")?.name} /{" "}
                        {getValues("rootFolder")?.name} /{" "}
                        {`{${getRecordName(getValues("module")?.apiName)}}__{${
                          getValues("module")?.displayLabel
                        } ID}`}
                      </strong>
                    </Typography>
                  ) : (
                    <></>
                  )}
                  {watch("service")?.apiName === "sharepoint" &&
                  watch("modulefield")?.fieldDisplayLabel ? (
                    <Typography variant="body2">
                      <strong>ℹ️ {getValues("module")?.displayLabel}</strong>{" "}
                      attachments will be saved in record folder. This folder Id
                      should exist in{" "}
                      <strong>
                        {getValues("modulefield")?.fieldDisplayLabel}
                      </strong>{" "}
                      field otherwise a folder will be created for each record
                      in below structure:{" "}
                      <strong>
                        {getValues("site")?.name} / {getValues("drive")?.name} /{" "}
                        {getValues("rootFolder")?.name} /{" "}
                        {`{${getRecordName(getValues("module")?.apiName)}}__{${
                          getValues("module")?.displayLabel
                        } ID}`}
                      </strong>
                    </Typography>
                  ) : (
                    <></>
                  )}
                  {watch("service")?.apiName === "sharepoint" &&
                  !watch("modulefield")?.fieldDisplayLabel ? (
                    <Typography variant="body2">
                      <strong>ℹ️ {getValues("module")?.displayLabel}</strong>{" "}
                      attachments will be saved in record folder. Folder will be
                      created for each record in below structure:{" "}
                      <strong>
                        {getValues("site")?.name} / {getValues("drive")?.name} /{" "}
                        {getValues("rootFolder")?.name} /{" "}
                        {`{${getRecordName(getValues("module")?.apiName)}}__{${
                          getValues("module")?.displayLabel
                        } ID}`}
                      </strong>
                    </Typography>
                  ) : (
                    <></>
                  )}
                </Box>
              ) : (
                <></>
              )}
            </>
          </Box>
        </DialogContent>
        <DialogActions
          sx={{ display: "flex", justifyContent: "flex-end", gap: "1rem" }}
        >
          <Button
            onClick={handleRevokeClose}
            variant="outlined"
            color="primary"
          >
            Cancel
          </Button>
          <Button
            type="submit"
            form="settingForm"
            variant="contained"
            color="primary"
            disabled={!getValues("rootFolder")}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default CreateNewSettingModal;
